'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var _isArray = /*#__PURE__*/require('./isArray');

var _isArray2 = /*#__PURE__*/_interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks if input value is an empty `Array`.
 *
 * @func isEmptyArray
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.4.0|v2.4.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotEmptyArray|isNotEmptyArray}
 * @example
 *
 * RA.isEmptyArray([]); // => true
 * RA.isEmptyArray([42]); // => false
 * RA.isEmptyArray({}); // => false
 * RA.isEmptyArray(null); // => false
 * RA.isEmptyArray(undefined); // => false
 * RA.isEmptyArray(42); // => false
 * RA.isEmptyArray('42'); // => false
 */
var isEmptyArray = /*#__PURE__*/(0, _ramda.both)(_isArray2.default, _ramda.isEmpty);

exports.default = isEmptyArray;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/isEmptyArray.js
// module id = 878
// module chunks = 168707334958949